module.exports = __webpack_public_path__ + "media/images/swiss/offers/digital-voucher-app@2x-22b594a967f4beb439842bded9dcfa90.jpg";